module.exports = __webpack_public_path__ + "static/media/animal-dog5.14609c07.aac";